export enum CustomPointType {
  text = <any>'text',
  image = <any>'image',
  em_movie = <any>'movie',
  em_sound = <any>'sound',
}
